import { UPDATE_SIDE_PANEL } from "state/ui/sidePanel/sidePanelActionTypes";

export const update = payload => {
  return {
    type: UPDATE_SIDE_PANEL,
    payload
  };
};
